import { jsx as o, jsxs as c } from "react/jsx-runtime";
import m from "react";
import l from "../../Icons/ChevronDown.js";
import { TopLevelNav as s, NavItem as d, NavLink as p } from "./styled.js";
const f = ({ activeId: e, items: t, onClick: r }) => /* @__PURE__ */ o(s, { role: "navigation", children: t.map((i) => {
  const { id: a, text: v } = i, n = a === e;
  return /* @__PURE__ */ o(d, { children: /* @__PURE__ */ c(
    p,
    {
      type: "button",
      $isActive: n,
      onClick: () => r(i),
      "aria-expanded": n,
      children: [
        v,
        /* @__PURE__ */ o(l, {})
      ]
    }
  ) }, a);
}) }), x = m.memo(
  f,
  (e, t) => e.activeId === t.activeId && e.items === t.items
);
export {
  x as default
};
